import React from 'react'
import { connect } from 'react-redux'
import LKModal, { LKModalContainer, actions as LKModalActions } from '../shared/LKModal'
import AccountSearch from './Components/AccountSearch'
import { translate } from './helpers'
import { closeAccGridSelector, closeSearchBarSelector, deleteAccountsSelector } from './actions'

const MODAL_NAME = 'AccountSelectModal'

export const open = ({ name }) => LKModalActions.open({ name })
export const close = () => LKModalActions.close(MODAL_NAME)

@LKModalContainer()
@connect(undefined, {
  closeAccGridSelector,
  closeSearchBarSelector,
  deleteAccountsSelector,
})
class AccountSelectModal extends React.PureComponent {
  componentWillUnmount() {
    const { onClose } = this.props
    if (onClose) onClose()
  }

  destroy = () => {
    this.props.closeAccGridSelector()
    this.props.closeSearchBarSelector()
    this.props.deleteAccountsSelector()
  }

  handleSelect = (params) => {
    const { onSelect, closeModal } = this.props

    // if onSelect returns falsy value then we handle default action (close & destroy)
    if (onSelect && !onSelect(params)) {
      this.destroy()
      closeModal()
    }
  }

  render() {
    const { modalInstanceName, accNo, ccy, page } = this.props

    return (
      <LKModal
        icon="account_search"
        name={modalInstanceName}
        heading={translate('frm_acc_search')}
        onClose={this.destroy}
        size="lg"
        footer={
          <LKModal.Footer sideActions={<LKModal.CancelButton text={translate('cmd_close')} onClick={this.destroy} />} />
        }
      >
        <AccountSearch selector onSelect={this.handleSelect} ccy={ccy} accNo={accNo} page={page} />
      </LKModal>
    )
  }
}

export default AccountSelectModal
